import {memo} from "react"

import {MC} from "./MC.js"

// small component for render html with dangerouslySetInnerHTML, it is memoized for avoid unnecessary rerenders, because html content can be the same but new object with html string is created on every render, 
// and it causes rerender of option component even if content is the same, because props are not equal by reference, with this component we can compare html string and avoid rerender if it is the same,
// without this was problem with first click to link iside html, it not wordked
const HtmlCustom = memo(({Tag, html, ...rest}) => {
  return <Tag {...rest} dangerouslySetInnerHTML={{__html: MC.customHtml(html)}} />
})

export default HtmlCustom